import { DesktopGenericService } from './DesktopGenericService';
import { MobileGenericService } from './MobileGenericService';
import * as React from 'react';
import { useVerticalServices } from '../../../hooks';

export interface IGenericServiceProps {
  title?: String;
  subtitle?: string;
  dataName: string;
  description: string[];
  bgColor: 'white' | 'gradient';
  checked: boolean;
  unavailable?: boolean;
  icon?: React.ReactNode;
  className?: string;
  children: React.ReactNode;

  onClick(): void;
}

export const GenericService = (props: IGenericServiceProps) => {
  const { showVerticalServices } = useVerticalServices();

  return showVerticalServices ? <MobileGenericService {...props} /> : <DesktopGenericService {...props} />;
};
